import React from 'react';
import colors from '../../utils/colors';

const ZeroCreditsBanner = () => {
  return (
    <div className="flex justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative overflow-hidden gap-2.5 px-[121px] py-3" style={{ backgroundColor: colors.states.danger }}>
      <p className="flex-grow-0 flex-shrink-0 text-xs text-left text-white">
        You've ran out of credits. <a href="#" className="underline">Upgrade</a>
      </p>
    </div>
  );
};

export default ZeroCreditsBanner;